import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const CardContainer = styled(Link)<{ $disabled?: boolean }>`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  box-shadow: ${({ theme }) => theme.shadows.medium};
  overflow: hidden;
  transition: transform 0.3s ease;
  text-decoration: none;
  display: block;
  padding: ${({ theme }) => theme.spacing.md};
  text-align: center;
  position: relative;
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};

  &:hover {
    transform: ${(props) => (props.$disabled ? 'none' : 'translateY(-5px)')};
  }
`;

export const DisabledOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
`;

export const WatermarkText = styled.div`
  font-size: 2rem;
  font-weight: bold;
  color: rgb(255, 107, 107);
  transform: rotate(-30deg);
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
`;

export const FlagContainer = styled.div`
  font-size: 6rem;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const CountryName = styled.h3`
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
`;

export const ArticleCount = styled.p`
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: ${({ theme }) => theme.spacing.xs} 0 0;
`;
